import { LOCALES } from "../locales";
import arJSON from "./ar_EG.json";
import enJSON from "./en_US.json";
const AppLocale = {
  [LOCALES.ARABIC]: {...arJSON},
  [LOCALES.ENGLISH]: {...enJSON},
};

export default AppLocale;
